export class StockTransferDetail {
    constructor(public TDID?, public TID?, public SID?, public SN?, public Cat?, public Qty?) { }
}